import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as PlusIcon } from 'components/UI/icons/add-line.svg'
import st from './Button.module.scss'

const Button = ({
  isDisabled,
  withIcon,
  onClick,
  to,
  text,
  whiteBtn,
  width,
}) => {
  const ButtonComponent = to ? Link : 'button'

  const commonProps = {
    onClick: onClick,
    to: to,
    className: `${st.btnReset} ${isDisabled ? st.customButtonDisabled : whiteBtn ? st.whiteButton : st.customButton}`,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '0 15px',
      minWidth: `${width}` || '170px',
      lineHeight: '16px',
      fontSize: '14px',
      cursor: isDisabled ? 'default' : 'pointer',
      opacity: isDisabled,
      textDecoration: 'none',
      height: '36px',
    },
    disabled: isDisabled,
  }

  return (
    <ButtonComponent {...commonProps}>
      {withIcon && <PlusIcon />}
      <span>{text}</span>
    </ButtonComponent>
  )
}

export default Button
